import { Component, Input } from '@angular/core';
import { SpeedScoreInfo, SpeedScoreService } from './speed-score.service';
import { Observable } from 'rxjs';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import { MetricCardHeader } from '../../metrics';
import { getImageSrc } from '../../../core/image-utilities';

@Component({
  selector: 'app-speed-score',
  templateUrl: './speed-score.component.html',
  styleUrls: ['./speed-score.component.scss'],
  standalone: false,
})
export class SpeedScoreComponent {
  @Input() domain: string;
  @Input() siteId: string;

  desktopSpeedScoreInfo$: Observable<SpeedScoreInfo>;
  mobileSpeedScoreInfo$: Observable<SpeedScoreInfo>;
  loadingDesktopSpeedScore$: Observable<boolean>;
  loadingMobileSpeedScore$: Observable<boolean>;
  desktopRefreshing$: Observable<boolean>;
  mobileRefreshing$: Observable<boolean>;

  desktopCardImage = getImageSrc('images/laptop.svg');
  mobileCardImage = getImageSrc('images/cellphone.svg');

  readonly cardConfig = {
    Desktop: {
      header: {
        title: { key: 'ANALYTICS.SPEED_SCORE_MODAL.TITLE.DESKTOP' },
        subtitle: { key: 'ANALYTICS.SPEED_SCORE_MODAL.SUBTITLES.DESKTOP' },
      } as MetricCardHeader,
    },
    Mobile: {
      header: {
        title: { key: 'ANALYTICS.SPEED_SCORE_MODAL.TITLE.MOBILE' },
        subtitle: { key: 'ANALYTICS.SPEED_SCORE_MODAL.SUBTITLES.MOBILE' },
      } as MetricCardHeader,
    },
  };

  readonly schemeColor = { domain: ['#1e88e5'] };

  constructor(
    private speedScoreService: SpeedScoreService,
    private snowplow: ProductAnalyticsService,
  ) {
    this.loadingDesktopSpeedScore$ = speedScoreService.loadingDesktopSpeedScore$;
    this.loadingMobileSpeedScore$ = speedScoreService.loadingMobileSpeedScore$;
    this.desktopSpeedScoreInfo$ = speedScoreService.desktopSpeedScoreInfo$;
    this.mobileSpeedScoreInfo$ = speedScoreService.mobileSpeedScoreInfo$;
    this.desktopRefreshing$ = speedScoreService.desktopRefreshing$;
    this.mobileRefreshing$ = speedScoreService.mobileRefreshing$;
  }

  /**
   * Takes users to web dev doc on why improving PageSpeed is important in a different tab.
   */
  public learnMore(): void {
    const url = `https://web.dev/why-speed-matters/`;
    window.open(url, '_blank');
  }

  /**
   * Takes users to the Google PageSpeed developers documentation in a different tab.
   */
  public improveSpeed(tab: 'desktop' | 'mobile'): void {
    const siteUrl = this.domain ? 'https://' + this.domain : '';
    const url = `https://developers.google.com/speed/pagespeed/insights/?url=${siteUrl}&tab=${tab}`;
    window.open(url, '_blank');
  }

  refreshScores(device: string): void {
    this.speedScoreService.instantFetch(this.domain, device, this.siteId);
  }
}
